module.exports = __webpack_public_path__ + "img/selected6-min.637328f0.png";